export default __webpack_public_path__ + "static/media/contact-light.227bc6c8.svg";